<template>
    <div id="success-creation-page">
        <div class="row m-0" style="width:100%;">
            <div class="col-lg-5 p-0">
                <div class="d-none d-lg-block">
                    <div class="row" id="left-div">
                        <div class="col-md-6" id="cover-img"></div>
                        <div class="col-md-6 p-5 cover-info">
                            <div>
                                <h1 class="mb-5">BECOME AN OBSERVER</h1>
                                <h2 class="mb-4">
                                    JOIN THE WILDLIFE PROTECTOR PRIVATE
                                    MEMBERSHIP
                                </h2>
                                <p>
                                    Be an observer and stay in the lookout for
                                    the latest updates and news about wildlife,
                                    their environment, and WWF's work.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cover-info text-center mt-5 d-block d-lg-none">
                    <h1 class="mb-5 mt-5 p-1">BECOME AN OBSERVER</h1>
                </div>
            </div>
            <div class="col-lg-7 p-0" id="success-div">
                <header class="site-header">
                    <div class="container">
                        <nav
                            class="navbar navbar-expand-lg navbar-light navbar-offcanvas py-0"
                        >
                            <a class="navbar-brand" href="/">
                                <img
                                    class="navbar-logo"
                                    src="/images/WWF_Logo.jpg"
                                />
                            </a>
                        </nav>
                    </div>
                </header>
                <div class="row" style="width:100%;">
                    <div class="col-md-2"></div>
                    <div class="col-md-8 p-0">
                        <div class="card-body p-5" id="otp-form">
                            <h1 class="mb-4">
                                CONGRATS! YOU ARE NOW A WILDLIFE OBSERVER!
                            </h1>
                            <div class="row">
                                <div class="col-md-12">
                                    <p>
                                        Become a Wildlife Hero by sponsoring
                                        equipment and tools for the team on the
                                        ground to protect the endangered
                                        wildlife and safeguard their homes!
                                    </p>
                                </div>
                                <div class="col-md-12 text-center mt-3">
                                    <img
                                        width="100"
                                        height="100"
                                        :src="
                                            '/storage/imgs/assets/loading.gif'
                                        "
                                    />
                                </div>
                                <div class="col-md-12">
                                    <p class="text-center" id="loading-message">
                                        Please wait while we redirect you to
                                        your account...
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
            <div class="col-12 p-0">
                <div class="cover-info text-center mt-5 d-block d-lg-none">
                    <h2 class="mb-1 p-1">
                        JOIN THE WILDLIFE PROTECTOR PRIVATE MEMBERSHIP
                    </h2>
                    <p class="mb-2 p-5">
                        Be an observer and stay in the lookout for the latest
                        updates and news about wildlife, their environment, and
                        WWF's work.
                    </p>
                    <div id="cover-img" style="height:80vh; width:100%;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- Event snippet for Tiger Protector Sign Up conversion page
In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. -->
<script>
function gtag_report_conversion(url) {
    var callback = function() {
        if (typeof url != "undefined") {
            window.location = url;
        }
    };
    gtag("event", "conversion", {
        send_to: "AW-663429940/JuNICI3txtEBELTGrLwC",
        event_callback: callback,
        event_label: "submit",
        event_category: "Submit",
        non_interaction: true
    });
    return false;
}
</script>
<script>
export default {
    created() {
        setTimeout(function() {
            window.location.href = "/user/adoptions";
        }, 3000);
    }
};
</script>
<style scoped>
header {
    background-color: transparent;
    position: absolute;
    width: 100%;
    top: 0;
}
#success-creation-page {
    margin: 0;
    padding: 0;
    min-width: 100%;
    min-height: 90vh;
}
#success-creation-page #left-div {
    padding: 0;
    background-color: black;
    min-height: 90vh;
}
#success-creation-page #left-div .col-6 {
    padding: 0;
}
#cover-img {
    background-image: url("/images/pages/checkout/Vertical-Join-Wildlife-Observer.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 100vh;
}
.cover-info,
#success-div {
    display: flex;
    justify-content: center;
    align-items: center;
}
.cover-info h1 {
    color: #ffca00;
    font-size: 3rem;
    margin-bottom: 1.5rem !important;
}
.cover-info h2 {
    color: white;
    font-size: 2rem;
}
.cover-info p {
    color: white;
    font-size: 1rem;
}
.cover-info h1,
.cover-info h2 {
    font-family: "WWF";
    line-height: 1;
}
#success-div .card-body {
    box-shadow: 0.2px 0.2px 20px gray;
    border-radius: 3px;
    background-color: white;
}
#success-div .card-body h1 {
    font-family: "WWF";
    font-size: 3em;
    text-align: left;
    line-height: 1;
}
#success-div button {
    background-color: #f58220;
    border: none;
    font-weight: bolder;
}
#loading-message {
    color: #f58220;
}
/* SMALL DEVICES */
@media only screen and (min-width: 600px) {
}
/* MEDIUM DEVICES */
@media only screen and (max-width: 992px) {
    #success-creation-page {
        background-color: black;
    }
}

#success-creation-page p.mb-2.p-5 {
    padding: 1rem 2.4rem 2.4rem !important;
}
#success-creation-page h2.mb-1.p-1 {
    padding-left: 2.4rem !important;
    padding-right: 2.4rem !important;
}
</style>
